import type { StaffingIssue } from "../../utils/autoStaffing";
import type { NurseRole, ScheduleData } from "../../utils/models";
import { roleKeys } from "../../utils/utilFunctions";

export const getRecommendationTitle = (rec: StaffingIssue, schedule: ScheduleData, isAutoScheduler?: boolean): { title: string; subtitle?: string } => {
	const firstSuggestion = rec.suggestions[0];
	const nurse = firstSuggestion ? schedule.nurses.find((n) => n.id === firstSuggestion.nurseId) : null;
	const fullText = rec.title.map((t) => t.text).join(" ");
	const role: `${NurseRole}` | "Nurse" = roleKeys.find((roleKey) => fullText.includes(roleKey)) || "Nurse";

	if (fullText.includes("overstaffed") || fullText.includes("overtime")) {
		return {
			title: "Reduce costs",
			subtitle: nurse && fullText.includes("overtime") ? `overtime for ${nurse.firstName}` : "shift overstaffed",
		};
	}
	if (fullText.includes("update the number of nurses needed")) {
		const actualNeededNurses = rec.title[3].text;
		return {
			title: `Reduce costs - Update (${role}) needed`,
			subtitle: `update to ${actualNeededNurses} needed nurses`,
		};
	}
	if (fullText.includes(" responses")) {
		const nurseName = rec.title[2]?.text;
		return {
			title: `Reduce costs - Replace (${role}) ${nurseName}`,
		};
	}
	if (fullText.includes("understaffed")) {
		return {
			title: isAutoScheduler ? `Move ${role}` : `Additional ${role}`,
			subtitle: "shift understaffed",
		};
	}
	if (fullText.includes("below ppd target")) {
		return {
			title: `Additional ${role}`,
			subtitle: "below ppd target",
		};
	}
	if (fullText.includes("post new open shift")) {
		return {
			title: "Reduce costs - Open Shift",
			subtitle: fullText.substring(fullText.indexOf("post new open shift") + "post new open shift".length).trim(),
		};
	}
	if (fullText.includes("without response yet")) {
		const nurseName = rec.title[2]?.text;
		return {
			title: `Reduce costs - Replace (${rec.title[1]?.text}) ${nurseName}`,
			subtitle: "no response yet",
		};
	}

	if (fullText.includes("trainee")) {
		const traineeName = rec.title.find((t) => t.type === "bold")?.text.trim() || "";
		return {
			title: "Trainee has no trainer",
			subtitle: `Trainer needed for ${traineeName}`,
		};
	}

	return {
		title: rec.title?.[0]?.text || "",
		subtitle: rec.title
			.slice(1)
			.map((t) => t.text)
			.join(" "),
	};
};

export const staffingStatusMap = new Map<string, string>([
	["is below", "Shift understaffed"],
	["shift understaffed", "Shift understaffed"],
	["shift  overstaffed", "Shift overstaffed"],
	["shift overstaffed", "Shift overstaffed"],
	["trainer needed", "Missing trainer"],
	["overtime for", "Staff on OT"],
	["below  ppd", "Shift understaffed"],
]);
